import { FC, useCallback, useState, useRef, useEffect } from 'react'
import styles from 'components/features/pfm/StripeCardNumber/StripeCardNumber.styl'
import { CardNumberElement, CardNumberElementProps } from '@stripe/react-stripe-js'
import { StripeCardNumberElementChangeEvent } from '@stripe/stripe-js'
import { CreditCardIcon } from 'components/features/pfm/CreditCardIcon/CreditCardIcon'

type StripeCardNumberProps =
  & CardNumberElementProps
  & {

  }

export const StripeCardNumber: FC<StripeCardNumberProps> = (props) => {
  const { onChange, ...restProps } = props

  const [brand, setBrand] = useState('unknown')

  // Sometimes Stripe fires events after component was unmount :(
  const isMountRef = useRef(true)
  useEffect(() => {
    isMountRef.current = true
    return () => {
      isMountRef.current = false
    }
  }, [])

  const handleChange = useCallback<(event: StripeCardNumberElementChangeEvent) => any>((event) => {
    if (!isMountRef.current) {
      return
    }

    const { brand: nextBrand, error, empty } = event
    let inferredIcon: string = nextBrand
    if (error) {
      inferredIcon = 'wrong'
    } else if (empty) {
      inferredIcon = 'unknown'
    }

    if (inferredIcon !== brand) {
      setBrand(inferredIcon)
    }
    onChange && onChange(event)
  }, [brand, onChange])

  return (
    <div className={ styles.stripeCardNumber }>
      <div className={ styles.input }>
        <CardNumberElement onChange={ handleChange } { ...restProps } />
      </div>
      <div className={ styles.icon }>
        <CreditCardIcon brand={ brand } />
      </div>
    </div>
  )
}
